<template>
  <Block :title="t('title')" emoji="🔔">
    <BlockList :items="storesToRelaunch" key-field="storeId">
      <template #default="{ item: store }">
        <span>
          {{ store.storeSalesChannel }}
          <span
            class="inline-flex items-center rounded-full px-1.5 py-px text-xs font-bold ml-1"
            :class="signalBadgeClass(store.signal)"
          >
            {{ t(`signal.${store.signal}`) }}
          </span>
        </span>
        <span class="font-bold whitespace-nowrap ml-3">{{ storeDetail(store) }}</span>
      </template>
    </BlockList>
  </Block>
</template>

<script>
import { Block, BlockList } from "@estaly/ui";
import { useI18n } from "vue-i18n";

const SIGNAL_CLASSES = {
  NEVER_ACTIVE: "bg-red-600 text-white",
  DROPPED: "bg-red-50 text-red-500 border border-red-200",
  FADING: "bg-purple-50 text-purple-600 border border-purple-300",
  SILENT: "bg-yellow-50 text-yellow-700 border border-yellow-400",
};

export default {
  components: {
    Block,
    BlockList,
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  props: {
    storesToRelaunch: {
      type: Array,
      required: true,
    },
  },
  methods: {
    signalBadgeClass(signal) {
      return SIGNAL_CLASSES[signal] || "bg-gray-100 text-gray-800";
    },
    storeDetail(store) {
      if (store.signal === "NEVER_ACTIVE") return this.t("no_sale");
      if (store.signal === "FADING") {
        return this.t("estompe_detail", { recent: store.recentSales ?? 0, previous: store.previousSales ?? 0 });
      }
      return this.t("days_without_sale", { count: store.daysWithoutSale });
    },
  },
};
</script>

<i18n src="./StoresToRelaunchBlock.i18n.json"></i18n>
